/**
 * ********************************************************************************************************************
 * Responsibility - Displays the order specs for a given order. This includes the product type, proof type, and other
 * details specific to the product type.
 * *************************************
 *
 * @format
 */

import {If, IfElse, useAccountContext} from 'frontier-utilities';
import {useProofingContext} from '../proofing_context_provider';
import {PROOF_TYPE_PRINTED} from 'frontier-constants';
import {OrderBasicDetails} from 'frontier-components';
import React, {useEffect, useState} from 'react';
import {OrderComments} from './order_comments';

// styles
import './order_info_cards.scss';

export const OrderSpecs = props => {
    const {className = ''} = props;

    const proofingCtx = useProofingContext();
    const accountCtx = useAccountContext();
    const {user} = accountCtx;

    const {reviewNotesVerification, specsVerification, order, currentProof} = proofingCtx.data;
    const {handleApproveSpecs, handleApproveNotes} = proofingCtx;

    const isPrintedProof = currentProof.type == PROOF_TYPE_PRINTED;

    const [isViewingAllSpecs, setIsViewingAllSpecs] = useState(false);

    const handleTriggerApproveSpecs = () => {
        handleApproveSpecs(user.email);

        // if there are no comments we need to approve the comments as well
        if (!currentProof.comment && currentProof.designs_alerts.length === 0) {
            handleApproveNotes(user.email);
        }
    };

    useEffect(() => {
        if (specsVerification.isVerified) {
            setIsViewingAllSpecs(false);
        }
    }, [specsVerification.isVerified]);

    return (
        <div className="oder-notes-44oo-container">
            <div className="order-specs-notes-container-98pw d-flex align-items-start justify-content-between bg-structure-lightest">
                <div className={`oder-specs-98pw ${className} w-100`}>
                    <div className="oder-specs-98pw__title-container d-flex align-items-start justify-content-between">
                        <div className="oder-specs-98pw__title d-flex align-items-start justify-content-start gap-3">
                            <If condition={specsVerification.isVerified}>
                                <i
                                    className="fa fa-check color-accent-primary"
                                    style={{fontSize: 24}}
                                />
                            </If>
                            <h3 className="color-structure-black m-0">Step 1: Order Specs</h3>
                        </div>
                    </div>

                    <OrderBasicDetails order={order} isViewingAllSpecs={isViewingAllSpecs} />

                    <If condition={isPrintedProof}>
                        <p className="mx-0 mt-4 mb-0">
                            <i>
                                This is a printed proof. Do not approve proof until you have
                                reviewed the physical copy.
                            </i>
                        </p>
                    </If>
                    <IfElse condition={!specsVerification.isVerified}>
                        <button
                            onClick={handleTriggerApproveSpecs}
                            className="btn btn--secondary btn-sm d-flex color-accent-primary gap-2 button--success  btn-outline-success mt-4">
                            <b>Approve</b>
                        </button>
                        <div className="oder-specs-98pw__specs-verified d-flex align-items-start justify-content-start gap-3 bg-structure-white mt-4">
                            <div>
                                <h4>Approved By</h4>
                                <p>{specsVerification.verifiedBy}</p>
                            </div>
                            <div>
                                <h4>Approved On</h4>
                                <p>{specsVerification.verifiedOn}</p>
                            </div>
                        </div>
                    </IfElse>
                </div>
                <OrderComments
                    className="proofing-container-0sx__comments w-100"
                    reviewNotesVerification={reviewNotesVerification}
                    handleApproveNotes={handleApproveNotes}
                    specsVerification={specsVerification}
                    currentProof={currentProof}
                    user={user}
                />
            </div>
        </div>
    );
};
